import React, { useEffect, useRef } from "react";

export default function Video(props) {
  const { playing } = props;

  useEffect(() => {
    if (playing) ref.current.play();
    else ref.current.pause();
  }, [playing]);

  const ref = useRef(null);

  return (
    <video src={props.src} ref={ref} height="300" onEnded={props.onEnded} />
  );
}
